import React from 'react'
import About from '../Components/Main/About'
import Skills from './Main/Skills'
import Projects from './Main/Projects'
import Contact from '../Components/Main/Contact'
import Home from './Main/Home'
import '../Styles/main.css'
const Main = () => {
  return (
    <div className='mainContainer'>
      <section id='home'>
        <Home />
      </section>
      <section id='about'>
        <About />
      </section>
      <section id='skills'>
        <Skills />
      </section>
      <section id='projects'>
        <Projects />
      </section>
      {/* <section id='contact'>
        <Contact />
      </section> */}
    </div>

  )
}

export default Main